import { get, post, remove } from 'services/api'
import { MIME_TYPES } from './constants/mimeTypes'

export const removeAttachment = async (attachmentID, answerId, token) => {
  return remove({
    url: `/attachment/${attachmentID}/remove`,
    params: { answer_uuid: answerId },
    token: token,
  })
}

export const removeAttachmentFromAnswerObjectOnly = async (attachmentID, answerId, token) => {
  return remove({
    url: `/attachment/${attachmentID}/remove-from-answer-only`,
    params: { answer_uuid: answerId },
    token: token,
  })
}


export const getAttachmentLink = async (attachmentID, token) => {
  return get({ url: `/attachment/${attachmentID}/find`, token: token }).then(
    (res) => res.data.document_url,
  )
}

/**
 * Extracts the file extension from a given filename.
 * @param {string} filename - The name of the file including the extension.
 * @returns {string} - The extension of the file.
 */
const getFileExtension = (filename) => {
  return filename.slice((Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1)
}

/**
 * Removes the file extension from a given filename.
 * @param {string} filename - The name of the file including the extension.
 * @returns {string} - The filename without the extension.
 * @example
 * // returns 'example'
 * removeFileExtension('example.txt')
 * // returns 'proof_of_residence'
 * removeFileExtension('proof_of_residence')
 */
const removeFileExtension = (filename) => {
  return filename.replace(/\.[^/.]+$/, "")
}

/** Creates an attachment by appending it to FormData and sending a POST request.
 * @param {Object} params - The parameters for creating an attachment.
 * @param {string} params.token - The token for authentication.
 * @param params.attachment - The attachment file.
 * @param {string} params.targetFilename - The name of the file.
 * The file extension will be removed.
 * @returns {Promise} - A Promise that resolves when the POST request is completed.
 * @example
 * createAttachment({ token: 'your_token', attachment: attachment, targetFilename: 'example' })
 * .then(response => console.log(response))
 */
export const createAttachment = async ({ token, attachment, targetFilename }) => {
  const file = new FormData()
  let newFileName = attachment.name

  if (targetFilename) {
    const extension = getFileExtension(attachment.name)
    newFileName = removeFileExtension(targetFilename)
    newFileName += extension ? `.${extension}` : ''
  }

  file.append('filename', newFileName)
  file.append('file', attachment)

  return post({
    url: '/attachment/upload',
    token,
    data: file,
    contentType: MIME_TYPES.FORM_DATA,
  })
}
